<template>
  <base-dialog v-model="isVisible" @show="setVScrollTarget">
    <dialog-template ref="dialogTemplate">
      <template slot="title">
        {{ $t('partners.choosing') }}
      </template>

      <virtual-scroll
        slot="content"
        :options="partnersList"
        :wrapper="vscrollTarget"
        :height="90"
      >
        <template v-slot:default="{ option, index}">
          <div
            :key="index"
            :class="$style.project"
          >
            <toggle-panel
              v-model="option.value"
              :title="option.name"
              @click="handleChangeByIdx(index)"
            >
              <project-logo slot="icon" :project="option" />
            </toggle-panel>
          </div>
        </template>
      </virtual-scroll>

      <simple-button slot="submit" variant="primary" @click="handleSubmit">
        {{ $t('common.save') }}
      </simple-button>

      <simple-button slot="cancel" variant="transparent" @click="handleClose">
        {{ $t('common.cancel') }}
      </simple-button>
    </dialog-template>
  </base-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import BaseDialog from 'molecules/base/Dialog';
import SimpleButton from 'molecules/common/SimpleButton';
import TogglePanel from 'molecules/panels/TogglePanel';
import ProjectLogo from 'molecules/project/ProjectLogo';
import DialogTemplate from 'templates/DialogTemplate';

import { EVENT_BUS } from '@/eventBus';
// import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';
import VirtualScroll from 'organisms/virtualscroll/VirtualScroll';

import { fetch as fetchPartner } from 'services/partner';

import Partnership from 'services/partner/Partnership';

function normalizeData(list) {
  return list.map(item => {
    return {
      ...item,
      value: true,
    };
  });
}

export default {
  name: 'SelectingPartners',
  components: {
    VirtualScroll,
    BaseDialog,
    SimpleButton,
    TogglePanel,
    ProjectLogo,
    DialogTemplate,
  },
  async created() {
    try {
      const partner = new Partnership();
      partner.setData(await fetchPartner());
      this.partnersList = [...partner.childProjects];
    } catch (error) {
      logrocket.logger(error);
      throw new Error(error);
    }

    EVENT_BUS.$emit('LOAD_PARTNERS', this.partnersList);

    EVENT_BUS.$on('SELECTING_PARTNERS', partners => {
      this.prepareData(this.partnersList, partners);
      this.isVisible = true;
    });
  },
  data() {
    return {
      partnersList: [],
      isVisible: false,
      vscrollTarget: null,
    };
  },
  computed: {
    isLockedToChange() {
      return this.partnersList.filter(type => type.value).length === 1;
    },
    getSelectedPartners() {
      return this.partnersList.filter(partner => partner.value);
    },
    ...mapGetters('partnership', ['getChildProjects']),
  },

  watch: {
    getChildProjects(value) {
      this.partnersList = [...value];
    },
  },
  methods: {
    ...mapMutations('partnership', [
      'SET_CHILD_PROJECTS',
      'PUSH_CHILD_PROJECTS',
    ]),

    setVScrollTarget() {
      this.vscrollTarget = this.$refs.dialogTemplate.$refs.content;
    },

    prepareData(rowData, selectedData = []) {
      const normalizedData = normalizeData(rowData);
      const activatedProjectIds = selectedData.map(partner => partner.projectId);

      if (this.$validate.isEmptyArray(activatedProjectIds)) {
        this.partnersList = normalizedData;
        return;
      }

      this.partnersList = normalizedData.map(item => {
        return {
          ...item,
          value: activatedProjectIds.includes(item.projectId),
        };
      });
    },
    handleChangeByIdx(idx) {
      const changedItem = this.partnersList[idx];

      if (changedItem.value && this.isLockedToChange) {
        this.$alert({
          type: 'warning',
          text: this.$t('must.choosed.one.value'),
        });
        return;
      }

      changedItem.value = !changedItem.value;
    },
    handleSubmit() {
      this.isVisible = false;

      EVENT_BUS.$emit('SELECTED_PARTNERS', this.getSelectedPartners);
    },
    handleClose() {
      this.isVisible = false;
    },
  },

};
</script>

<style lang="sass" module>
.project
  margin-bottom: 10px

  &:last-child
    margin-bottom: 0
</style>
